import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {TranslocoService} from '@jsverse/transloco';
import {PageService} from '../services/page.service';

@Injectable({
  providedIn: 'root',
})
export class PageDataResolver implements Resolve<any> {
  pageService = inject(PageService);
  translocoService = inject(TranslocoService);

  resolve(route: ActivatedRouteSnapshot): void {
    this.pageService.setDocumentPageTitle({
      key: route.data['documentPageTitle'] || 'global.application.pageTitle',
      params: {},
    });
    this.pageService.setCurrentPageTitle({
      key: route.data['pageTitle'] || 'home.title',
      params: {},
    });
    this.pageService.setShowBackLink(route.data['showBackLink'] || false);
  }
}
